// extracted by mini-css-extract-plugin
module.exports = {"payment-history":"payment-history__1GtYF","col":"col__6BYwm","title":"title__2wipS","detail":"detail__3feOG","action":"action__2XR2d"};